import { useWindowSize } from "@abmg-components"
import React from "react"
import styled, { createGlobalStyle } from "styled-components"

// Client-side package
let ReactApexChart
if (typeof window !== undefined && typeof window === "object") {
  ReactApexChart = require("react-apexcharts")
}

// import { ResponsivePie } from "@nivo/pie"

const DonutStyles = createGlobalStyle`
  .apexcharts-datalabel-label {
    color: var(--dusky-grey-6-hex);
    font-size: 2rem;
    font-weight: 600;
  }
  .apexcharts-datalabel-value {
    color: var(--dusky-grey-6-hex);
    font-size: 1rem;
  }
  .legend-box {
    width: 15px;
    height: 15px;
  }
  .tooltip {
    align-items: center;
    background-color: white;
    font-size: 18px;
    padding: 4px 8px;
    display: flex; 
    gap: 8px;
  }
`

const Donut = props => {
  if (typeof window !== "object") return null
  const Chart = ReactApexChart.default
  const series = props.pieData.map(data => {
    return data.value
  })

  const options = {
    chart: {
      type: "donut",
      redrawOnParentResize: true,
    },

    colors: props.pieData.map(data => {
      return data.color
    }),
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        width: 100,
        donut: {
          size: "90%",
          labels: {
            show: true,
            total: {
              showAlways: true,
              show: true,
              label: `$${props.monthlyTotal}`,
              color: "#000",
              formatter: () => {
                return `Monthly payment`
              },
            },
          },
        },
      },
    },
    labels: props.pieData.map(data => {
      return data.label
    }),
    legend: {
      show: false,
    },
    tooltip: {
      style: {
        backgroundColor: "#fff",
        fontSize: "16px",
      },
      theme: "light",
      custom: ({ series, seriesIndex, dataPointIndex, w }) => {
        const dataPoint = props.pieData[seriesIndex]
        return `<div class="tooltip"><div class="legend-box" style="background: ${dataPoint.color};"></div> <span>${dataPoint.label}: <b>$${dataPoint.value}</b></span></div>`
      },
    },
  }
  return (
    <>
      <DonutStyles />
      <Chart options={options} series={series} type="donut" />
    </>
  )
  // return (
  //   <>
  //     <ResponsivePie
  //       data={props.pieData}
  //       innerRadius={0.9}
  //       padAngle={0}
  //       colors={d => d.color}
  //       cornerRadius={0}
  //       borderWidth={0}
  //       enableRadialLabels={false}
  //       enableSlicesLabels={false}
  //       animate={true}
  //       motionStiffness={10}
  //       motionDamping={15}
  //     />
  //   </>
  // )
}
export default Donut
